// ==========================================================================
// CACTUS KNIGHT — Produktbild-Lightbox
// Klick auf Hauptbild öffnet die Vollbild-Vorschau. Ein weiterer Klick auf
// das Bild zoomt hinein/heraus. Während gezoomt ist, kann per Ziehen
// (Hand-Cursor) im Bild verschoben werden; die einzige weitere erlaubte
// Aktion ist, wieder herauszuzoomen — Navigation und Schließen sind dann
// deaktiviert. Pfeile bzw. Tasten wechseln zwischen den Produktbildern,
// wenn nicht gezoomt ist.
//
// 23.08.2026: Trackpad-Wischen (horizontal) hinzugefügt, damit man am
// Laptop wie mit dem Finger auf dem Handy zwischen Bildern wechseln kann.
//
// BUGFIX 23.08.2026 (2): Ein Zwei-Finger-Wisch auf dem Trackpad wird von
// macOS oft zusätzlich als Pinch-Zoom-Geste interpretiert — der Browser
// bekommt dann ein "wheel"-Event mit ctrlKey:true und führt SEINEN EIGENEN
// Seiten-Zoom aus (das Bild "wurde größer/kleiner"). Das war vorher nicht
// abgefangen. Jetzt wird JEDES wheel-Event mit ctrlKey innerhalb der
// Lightbox per preventDefault() blockiert, bevor der Browser reagieren
// kann — nur die eigene, kontrollierte Bildwechsel-Logik bleibt aktiv.
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.getElementById("gallery-main-trigger");
  const lightbox = document.getElementById("lightbox");
  if (!trigger || !lightbox) return;

  const stage = document.getElementById("lightbox-stage");
  const lightboxImg = document.getElementById("lightbox-img");
  const closeBtn = document.getElementById("lightbox-close");
  const prevBtn = document.getElementById("lightbox-prev");
  const nextBtn = document.getElementById("lightbox-next");
  const counterEl = document.getElementById("lightbox-counter");
  const mainImg = document.getElementById("gallery-main-img");
  const thumbs = Array.from(document.querySelectorAll(".product-gallery__thumb"));

  let currentIndex = 0;

  // ---- Zoom/Pan-Status ----
  let isDragging = false;
  let dragMoved = false;
  let dragStartX = 0;
  let dragStartY = 0;
  let offsetX = 0;
  let offsetY = 0;

  function galleryImages() {
    return thumbs.map((t) => ({
      src: t.dataset.full || t.querySelector("img").getAttribute("src"),
      alt: t.querySelector("img").getAttribute("alt"),
    }));
  }

  function setActiveThumb(index) {
    thumbs.forEach((t) => t.classList.remove("is-active"));
    if (thumbs[index]) thumbs[index].classList.add("is-active");
  }

  function showInMain(index) {
    const images = galleryImages();
    const img = images[index];
    if (!img) return;
    currentIndex = index;
    mainImg.setAttribute("src", img.src);
    setActiveThumb(index);
  }

  function updateCounter(index, total) {
    if (counterEl) counterEl.textContent = `${index + 1} / ${total}`;
  }

  function resetZoomOffset() {
    offsetX = 0;
    offsetY = 0;
    lightboxImg.style.transform = "";
  }

  function exitZoom() {
    lightbox.classList.remove("is-zoomed");
    lightbox.classList.remove("is-highlighted");
    resetZoomOffset();
  }

  function openLightbox(index) {
    currentIndex = index;
    const images = galleryImages();
    lightboxImg.setAttribute("src", images[index].src);
    lightboxImg.setAttribute("alt", images[index].alt);
    exitZoom();
    updateCounter(index, images.length);
    lightbox.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
  }

  function closeLightbox() {
    lightbox.setAttribute("hidden", "");
    exitZoom();
    document.body.style.overflow = "";
    // Hauptbild im Hintergrund auf den zuletzt im Lightbox gezeigten Stand bringen
    showInMain(currentIndex);
  }

  function showLightboxImage(index) {
    const images = galleryImages();
    const total = images.length;
    const safeIndex = (index + total) % total;
    currentIndex = safeIndex;
    lightboxImg.setAttribute("src", images[safeIndex].src);
    lightboxImg.setAttribute("alt", images[safeIndex].alt);
    exitZoom();
    updateCounter(safeIndex, total);
  }

  // ---- Öffnen über Hauptbild ----
  trigger.addEventListener("click", () => {
    openLightbox(currentIndex);
  });

  // Global verfügbar machen, damit auch die mobile Galerie die Lightbox
  // öffnen kann (Zoom/Vorschau auf dem Handy wie auf dem Desktop).
  window.ckOpenLightbox = (index) => openLightbox(index || 0);

  // ---- Öffnen über Thumbnails (zeigt zusätzlich im Hauptbild) ----
  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => showInMain(index));
  });

  // ---- Schließen ---- Der X-Button schließt die Vorschau immer, auch aus
  // dem gezoomten Zustand heraus (closeLightbox setzt den Zoom mit zurück).
  closeBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    closeLightbox();
  });
  lightbox.addEventListener("click", (e) => {
    if (e.target === lightbox && !lightbox.classList.contains("is-zoomed")) {
      closeLightbox();
    }
  });

  // ---- Zoom per Klick + Verschieben per Ziehen ----
  function clampOffset(x, y) {
    const stageRect = stage.getBoundingClientRect();
    const imgRect = lightboxImg.getBoundingClientRect();
    const maxX = Math.max(0, (imgRect.width - stageRect.width) / 2 + 40);
    const maxY = Math.max(0, (imgRect.height - stageRect.height) / 2 + 40);
    return {
      x: Math.min(maxX, Math.max(-maxX, x)),
      y: Math.min(maxY, Math.max(-maxY, y)),
    };
  }

  lightboxImg.addEventListener("pointerdown", (e) => {
    if (!lightbox.classList.contains("is-zoomed")) return;
    isDragging = true;
    dragMoved = false;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    lightbox.classList.add("is-dragging");
    lightboxImg.setPointerCapture(e.pointerId);
  });

  // Natives HTML5-Bild-Drag zuverlässig unterbinden (sonst startet der
  // Browser beim Ziehen einen Drag-Ghost mit "Verboten"-Cursor statt des
  // eigenen Pans).
  lightboxImg.addEventListener("dragstart", (e) => e.preventDefault());

  lightboxImg.addEventListener("pointermove", (e) => {
    if (!isDragging) return;
    const dx = e.clientX - dragStartX;
    const dy = e.clientY - dragStartY;
    if (Math.abs(dx) > 4 || Math.abs(dy) > 4) dragMoved = true;
    const clamped = clampOffset(offsetX + dx, offsetY + dy);
    lightboxImg.style.transform = `translate(${clamped.x}px, ${clamped.y}px)`;
  });

  function endDrag(e) {
    if (!isDragging) return;
    isDragging = false;
    lightbox.classList.remove("is-dragging");
    const dx = e.clientX - dragStartX;
    const dy = e.clientY - dragStartY;
    const clamped = clampOffset(offsetX + dx, offsetY + dy);
    offsetX = clamped.x;
    offsetY = clamped.y;
  }
  lightboxImg.addEventListener("pointerup", endDrag);
  lightboxImg.addEventListener("pointercancel", endDrag);

  // ---- Eingabeart erkennen: Touch-Geräte bekommen das Doppeltipp-
  // Verhalten (erst hervorheben, dann zoomen), Desktop das direkte
  // Klick-zoomt-Verhalten. ----
  const isTouch = window.matchMedia("(hover: none) and (pointer: coarse)").matches
    || ("ontouchstart" in window);

  let lastTapTime = 0;
  let highlightTimer = null;

  function setHighlight(on) {
    lightbox.classList.toggle("is-highlighted", on);
    if (highlightTimer) {
      clearTimeout(highlightTimer);
      highlightTimer = null;
    }
    if (on) {
      highlightTimer = setTimeout(() => {
        lightbox.classList.remove("is-highlighted");
      }, 1600);
    }
  }

  function toggleZoom() {
    if (lightbox.classList.contains("is-zoomed")) {
      exitZoom();
    } else {
      setHighlight(false);
      lightbox.classList.add("is-zoomed");
    }
  }

  lightboxImg.addEventListener("click", (e) => {
    e.stopPropagation();
    if (dragMoved) {
      dragMoved = false;
      return;
    }

    if (isTouch) {
      // Handy: Doppeltipp zoomt rein/raus, Einzeltipp hebt hervor.
      const now = Date.now();
      if (now - lastTapTime < 300) {
        lastTapTime = 0;
        toggleZoom();
      } else {
        lastTapTime = now;
        if (!lightbox.classList.contains("is-zoomed")) {
          setHighlight(!lightbox.classList.contains("is-highlighted"));
        }
      }
      return;
    }

    // Desktop: einfacher Klick zoomt rein/raus.
    toggleZoom();
  });

  // ---- Navigation ---- Am Desktop auch im Zoom nutzbar (Pfeile + Tastatur);
  // am Handy im Zoom gesperrt (erst entzoomen; Pfeile dort per CSS aus).
  function navBlockedByZoom() {
    return isTouch && lightbox.classList.contains("is-zoomed");
  }

  prevBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    if (navBlockedByZoom()) return;
    showLightboxImage(currentIndex - 1);
  });
  nextBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    if (navBlockedByZoom()) return;
    showLightboxImage(currentIndex + 1);
  });

  // ---- Trackpad-Wischen (horizontal) ----
  // Ein Trackpad-Zweifinger-Wisch feuert ein normales "wheel"-Event mit
  // horizontalem deltaX. Wir verlangen deltaX klar groesser als deltaY
  // (sonst wuerde normales vertikales Mausrad-Scrollen faelschlich auch
  // navigieren) UND einen Mindestwert, damit ein einzelner, entschlossener
  // Wisch reicht, kein winziges Zittern. Ein kurzer Cooldown verhindert,
  // dass EIN Wisch (der viele einzelne wheel-Events ausloest) versehentlich
  // mehrere Bilder auf einmal weiterspringt.
  //
  // BUGFIX: ctrlKey-wheel-Events (macOS-Pinch-Simulation) IMMER zuerst
  // abfangen und blockieren, bevor der Browser sie als Seiten-Zoom
  // interpretieren kann — unabhaengig davon, ob unsere eigene
  // Navigations-Bedingung sonst zutrifft.
  let wheelCooldown = false;
  stage.addEventListener(
    "wheel",
    (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
        return;
      }
      if (navBlockedByZoom()) return;
      if (Math.abs(e.deltaX) < 12 || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      if (wheelCooldown) return;
      wheelCooldown = true;
      showLightboxImage(currentIndex + (e.deltaX > 0 ? 1 : -1));
      setTimeout(() => {
        wheelCooldown = false;
      }, 450);
    },
    { passive: false }
  );

  // ---- Tastatursteuerung ----
  document.addEventListener("keydown", (e) => {
    if (lightbox.hasAttribute("hidden")) return;
    const zoomed = lightbox.classList.contains("is-zoomed");
    if (e.key === "Escape") {
      if (zoomed) {
        exitZoom();
      } else {
        closeLightbox();
      }
      return;
    }
    if (isTouch && zoomed) return;
    if (e.key === "ArrowLeft") showLightboxImage(currentIndex - 1);
    if (e.key === "ArrowRight") showLightboxImage(currentIndex + 1);
  });
});
